import { useTheme } from "@mui/material";
import { useMemo } from "react";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export type CompositionSlice = {
	id: string;
	value: number;
	label: string;
	color: string;
};

export const useGoalDetailComposition = (
	goal: GoalDetail,
): CompositionSlice[] => {
	const { t } = useResource();
	const { palette } = useTheme();

	return useMemo<CompositionSlice[]>(() => {
		const totalAccountedFor =
			goal.ownFunds + goal.loanAmount + goal.coveredAmount;
		const remaining = Math.max(0, goal.totalValue - totalAccountedFor);
		return [
			{
				id: "own",
				value: goal.ownFunds,
				label: t(Resources.Goals.Detail.Composition.ownFunds),
				color: palette.blue[300],
			},
			{
				id: "loan",
				value: goal.loanAmount,
				label: t(Resources.Goals.Detail.Composition.loan),
				color: palette.amber[600],
			},
			{
				id: "invest",
				value: goal.coveredAmount,
				label: t(Resources.Goals.Detail.Composition.savings),
				color: palette.indigo[300],
			},
			{
				id: "remaining",
				value: remaining,
				label: t(Resources.Goals.Detail.Composition.remaining),
				color: palette.grey[200],
			},
		].filter((s) => s.value > 0);
	}, [goal, t, palette]);
};
